import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useMediaDevice } from '@elem/compPage/Oasis/hooks';
import EcoImg from 'eco-design/base/eco-img';
import { useState, useEffect } from 'react';

interface ItemType {
    img: string[];
    title: string[];
    row: string[][];
}
export default function Modal({ callback }: any) {
    const { t } = useLang('shp3');
    // const { isH5, isPad } = useMediaDevice();
    const [visible, setVisible] = useState(false);
    const [isPad, setIsPad] = useState(false);
    const handleResize = () => {
        if (typeof window === 'undefined') return;
        setIsPad(window.innerWidth < 1024);
    };
    useEffect(() => {
        if (typeof window === 'undefined') return;
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const items: ItemType = {
        img: [
            '',
            'https://websiteoss.ecoflow.com/upload/image/1759048187723/Frame%201612707752.png',
            'https://websiteoss.ecoflow.com/upload/image/1759048187888/Frame%201612708225.png',
        ],
        title: ['', t('B_modal_item_title1'), t('B_modal_item_title2')],
        row: [
            [t('B_modal_item1_label1'), t('B_modal_item2_desc1'), t('B_modal_item3_desc1')],
            [t('B_modal_item1_label2'), t('B_modal_item2_desc2'), t('B_modal_item3_desc2')],
            [t('B_modal_item1_label3'), t('B_modal_item2_desc3'), t('B_modal_item3_desc3')],
            [t('B_modal_item1_label4'), t('B_modal_item2_desc4'), t('B_modal_item3_desc4')],
        ],
    };

    const handleClose = () => {
        setVisible(false);
        setTimeout(() => {
            callback();
        }, 200);
    };

    useEffect(() => {
        setTimeout(() => {
            setVisible(true);
        }, 200);
    }, []);

    return (
        <div
            className={`dpux-modal-terms ${css.modal} GtmModuleData-section ${visible ? 'visible' : ''}`}
            data-section-id={css.modal}
            data-section-title={t('I_modal_title')}
        >
            <div className="mask"></div>
            <div className={`content ${visible ? 'visible' : ''} pc`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none" onClick={handleClose}>
                    <circle cx="10" cy="10" r="10" fill="white" fillOpacity="0.4" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.76758 9.82812L6.46918 12.1265C6.17629 12.4194 6.17629 12.8943 6.46918 13.1872C6.76207 13.4801 7.23695 13.4801 7.52984 13.1872L9.82824 10.8888L12.1266 13.1872C12.4195 13.4801 12.8944 13.4801 13.1873 13.1872C13.4802 12.8943 13.4802 12.4194 13.1873 12.1265L10.8889 9.82812L13.1867 7.53033C13.4796 7.23744 13.4796 6.76256 13.1867 6.46967C12.8938 6.17678 12.4189 6.17678 12.126 6.46967L9.82824 8.76746L7.53045 6.46967C7.23755 6.17678 6.76268 6.17678 6.46979 6.46967C6.17689 6.76256 6.17689 7.23744 6.46979 7.53033L8.76758 9.82812Z"
                        fill="white"
                    />
                </svg>
                <p className="modal-title">{'Choose Your Intelligent Panel'}</p>
                <ul className="modal-items">
                    <li>
                        {items.img.map((item, index) => {
                            if (item) {
                                return <EcoImg className="modal-item-img" pc={item} />;
                            } else {
                                return <div className="modal-item-Blank"></div>;
                            }
                        })}
                    </li>
                    <li>
                        {items.title.map((item, index) => {
                            return <p className="modal-item-title">{item}</p>;
                        })}
                    </li>
                    {items.row.map((item, index) => {
                        if (isPad) {
                            return (
                                <li>
                                    <p className={`modal-item-label`}>{item[0]}</p>
                                    <div className="desc-box">
                                        {item.map((i, k) => {
                                            if (k !== 0) {
                                                return <p className={`modal-item-desc`}>{i}</p>;
                                            }
                                        })}
                                    </div>
                                </li>
                            );
                        } else {
                            return (
                                <li>
                                    {item.map((i, k) => {
                                        return <p className={`modal-item-${k === 0 ? 'label' : 'desc'}`}>{i}</p>;
                                    })}
                                </li>
                            );
                        }
                    })}
                </ul>
                <p className="footer">{t('B_modal_footer')}</p>
            </div>
        </div>
    );
}
